"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const store_1 = require("../context/store");
const en_json_1 = __importDefault(require("./en.json"));
const ru_json_1 = __importDefault(require("./ru.json"));
const zh_json_1 = __importDefault(require("./zh.json"));
const es_json_1 = __importDefault(require("./es.json"));
const it_json_1 = __importDefault(require("./it.json"));
const de_json_1 = __importDefault(require("./de.json"));
const fr_json_1 = __importDefault(require("./fr.json"));
const ja_json_1 = __importDefault(require("./ja.json"));
const constants_1 = require("../data/constants");
const messageMap = {
    en: en_json_1.default,
    ru: ru_json_1.default,
    es: es_json_1.default,
    zh: zh_json_1.default,
    it: it_json_1.default,
    de: de_json_1.default,
    fr: fr_json_1.default,
    ja: ja_json_1.default, // japan
};
const cache = (0, react_intl_1.createIntlCache)();
const Intl = ({ children }) => {
    const { locale } = (0, store_1.useTrackedState)();
    const intl = (0, react_1.useMemo)(() => {
        const messages = messageMap[locale];
        const fallbackMessages = messageMap[constants_1.DEFAULT_LOCALE];
        return (0, react_intl_1.createIntl)({
            locale,
            defaultLocale: constants_1.DEFAULT_LOCALE,
            messages: messages || fallbackMessages,
        }, cache);
    }, [locale]);
    return react_1.default.createElement(react_intl_1.RawIntlProvider, { value: intl }, children);
};
exports.default = Intl;
//# sourceMappingURL=index.js.map